<nav class="navbar header navbar-expand-lg fixed-top justify-content-center justify-content-end-mobile" aria-label="Site menu logged in">
	<button *ngIf="user && user.vigente && user.tipoUsuario != 'Docente'" id="cstm-side-menu-btn" (click)="mostrarSidebar()" class="btn"><i class="bi bi-list menu_hamburguesa"></i></button>
	<a [href]="redirectLogoUrl">
		<img class="responsive size-logo mr-4 img-logo-duoc-menu" src="./assets/img/logo-duoc.svg" alt="logo-duoc" />
	</a>
	<h2 class="mb-0 ocultar-mobile">Portal de calificaciones</h2>
	<div *ngIf="user" class="row separacion_nombre_usuario_titulo ocultar-mobile">
		<div class="col-12">
			<div class="header_nombre cursor-pointer">
				Bienvenid@  &nbsp;<strong class="header_nombre-docente">{{ user.nombre }} {{ user.apellidoPaterno }}</strong>&nbsp;
			</div>
			<div class="header_correo">
				{{ user.correo }}
			</div>
		</div>
	</div>
	<p *ngIf="user" class="ocultar-mobile nuevo-cerrar-sesion" (click)="logout()">Cerrar Sesión</p>

	<button *ngIf="user" (click)="logout()" class="btn btn-cerrar-sesion-mobile btn-cerrar-sesion-mobile-new"><i class="bi bi-box-arrow-right"></i></button>
</nav>

<!-- BOTÓN CERRAR SESIÓN -->

<div *ngIf="showLogoutBtn" class="container d-flex justify-content-end">
    <button (click)="logout()" class="btn cerrar_sesion">
        <p style="color:white" class="text-center mt-2">CERRAR SESIÓN</p>
    </button>
</div>

<!-- FIN BOTÓN CERRAR SESIÓN -->

<div class="fondo_menu" [ngClass]="{'d-none': !showMenu}">
	<!-- animate__animated animate__fadeIn -->
	<div id="cstm-side-menu" class="d-flex flex-column flex-shrink-0 p-3 bg-light fondo_menu-blanco">
		<div class="container">
			<div class="" *ngFor="let item of menuItems; index as ind">
				<div class="row align-items-center mt-4" (click)="item.showItem = !item.showItem">
					<div class="col-1">
						<i class="bi iconos-menu" [ngClass]="item.icono"></i>
					</div>
					<div class="col-6">
						<span class="titulo_principal-menu">{{ item.nombre }}</span>
					</div>
					<div class="col-4 text-right">
						<button class="btn"><i [ngClass]="item.showItem ? 'bi-chevron-up' : 'bi-chevron-down'" class="bi tamanio_icono-chevron"></i></button>
					</div>
				</div>
				<hr class="ml-5 mt-1">
				<ul class="nav nav-pills flex-column mb-auto ml-4" [ngClass]="{'d-none': !item.showItem}">
					<li class="nav-item" *ngFor="let subitem of item.menus">
						<a (click)="mostrarSidebar()" [routerLink]="'/'+subitem.url" class="nav-link titulo_submenu" aria-current="page">
							{{ subitem.nombre }}
						</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</div>

<!-- MENU HAMBURGUESA HEADER MOBILE -->

